import { createAction, props, union } from '@ngrx/store';


export const selectContact = createAction('[CustomerFilter] SELECT_CONTACT', props<{ contactId: number}>());
export const selectAuthorized = createAction('[CustomerFilter] SELECT_AUTHORIZED', props<{ authorized: boolean }>());

export const SetFilterFormExpanded = createAction(
  '[CustomerFilter] SET_FILTER_FORM_EXPANDED',
  props<{ expanded: boolean }>()
);

export const CustomerFilterActions = union({
  selectContact, selectAuthorized, SetFilterFormExpanded,
});
